<template>
	<div class="max-w-2xl mt-10 mx-auto px-4 sm:px-6 lg:px-8">

		<div v-if="hasPasted"
			 class="bg-green-200 mb-4 p-4 rounded">
			<span>
				Valid paste! Processing now...
			</span>
		</div>

		<div>
			<h3 class="text-lg leading-6 font-medium text-gray-900">Paste Clipboard to Die and Dump</h3>
			<p class="mt-1 text-sm text-gray-500">This will read clipboard and return it as a DD window.</p>
		</div>

	</div>
</template>

<script setup>

import {useForm} from "@inertiajs/vue3";
import {ref} from "vue";

const clipboard = ref([]);
const hasPasted = ref(false);

document.addEventListener('paste', function(e){

	const output = extractData(e.clipboardData)
		.then((response) => {
			// console.log(response.types)
			clipboard.value = response.types
			form.clipboard = response.types;
			return response.types
		})

	output.then((r) => {
		form.clipboard = [r]
		console.log(form.clipboard)
	});
	// console.log(Promise.resolve(output))

	hasPasted.value = true;
	submit(output);


});

async function extractData(data) {

	if (!data) {
		return undefined;
	}

	const file_info = file =>
		file
			? {
				name: file.name,
				size: file.size,
				type: file.type,
				url: URL.createObjectURL(file)
			}
			: null;

	if (data instanceof DataTransfer) {
		return {
			type: 'DataTransfer',
			types: Array.from(data.types).map(type => ({
				type,
				data: data.getData(type)
			})),
			items: data.items
				? Array.from(data.items).map(item => ({
					kind: item.kind,
					type: item.type,
					as_file: file_info(item.getAsFile())
				}))
				: null,
			files: data.files ? Array.from(data.files).map(file_info) : null
		};
	}

	if (data instanceof ClipboardItem) {
		return {
			type: 'ClipboardItem',
			types: await Promise.all(
				Array.from(data.types).map(async type => {
					const blob = await data.getType(type);
					return {
						type: type,
						data: blob.type.match(/^text\//)
							? await blob.text()
							: file_info(blob)
					};
				})
			)
		};
	}
	return undefined;
}


const form = useForm({
	clipboard: [],
});

function submit(output) {


	output.then((result) => {

			form
				.transform((data) => ({
					...data,
					clipboard: [result],
				}))
				.post('/dd', {
					onSuccess: () => {
						// location.reload();
					}
				});

		});



}


</script>
